// extracted by mini-css-extract-plugin
export var info = "style-module--info--6716b";
export var list = "style-module--list--a3f40";
export var speakers = "style-module--speakers--98db8";